<template lang="pug">
div.wrap-atom-bone-joint-picker
  div(v-for="item in rightHandBones"
    @click="onJoint(item)"
    :class="`joint-${item.name} ${(currentJoint && currentJoint.name == item.name) ? 'active' : ''}`").joint.cursor-pointer
  v-img(src="/img/icon/right-hand.svg")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$joint_size: 12px;
.wrap-atom-bone-joint-picker {
  position: relative;
  width: 240px;
  height: 240px;
  .joint {
    position: absolute;
    width: $joint_size; height: $joint_size;
    border-radius: 100%;
    z-index: 1;
    background: $secondary_bg_color;
    &.active {
      background: $active_color;
    }
    // offsetで中央に整列
    margin-left: calc(-#{$joint_size} / 2 + 50%); margin-top: calc(-#{$joint_size} / 2 + 50%);
  }
  .joint-RightIndexDistal {
    top: -34%; left: 11%;
  }
  .joint-RightIndexIntermediate {
    top: -20%; left: 11%;
  }
  .joint-RightIndexProximal {
    top: -2%; left: 11%;
  }

  .joint-RightMiddleDistal {
    top: -42%; left: -4%;
  }
  .joint-RightMiddleIntermediate {
    top: -22%; left: -4%;
  }
  .joint-RightMiddleProximal {
    top: -2%; left: -4%;
  }

  .joint-RightRingDistal {
    top: -37%; left: -18.5%;
  }
  .joint-RightRingIntermediate {
    top: -20%; left: -18.5%;
  }
  .joint-RightRingProximal {
    top: -2%; left: -18.5%;
  }

  .joint-RightLittleDistal {
    top: -26%; left: -33%;
  }
  .joint-RightLittleIntermediate {
    top: -14%; left: -33%;
  }
  .joint-RightLittleProximal {
    top: -2%; left: -33%;
  }

  .joint-RightThumbDistal {
    top: -2%; left: 32%;
  }
  .joint-RightThumbMetacarpal {
    top: 21%; left: 20%;
  }
  .joint-RightThumbProximal {
    top: 9%; left: 27%;
  }
}
</style>

<script>
import { rightHandBones } from '@/plugins/vrm-nums'

export default {
  data () {
    return {
      currentJoint: null
    }
  },
  computed: {
    rightHandBones () {
      return rightHandBones
    }
  },
  methods: {
    onJoint (joint) {
      this.currentJoint = joint
      this.$emit('setCurrentJoint', joint)
    }
  }
}
</script>
